import { DataProviderArgs } from "../../DataStore/DataProvider";
import { awsToSimpleUser, IUserInfo } from "../cloud/UserTable";

import { GraphQLTable } from "./GraphQLTable";

export class UserTable extends GraphQLTable<IUserInfo> {
    constructor(args: DataProviderArgs) {
        super(
            args,
            [],
            { get: "getUserInfo", list: "listUserInfos", create: "createUserInfo" },
            awsToSimpleUser
        );
    }
}
